var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTwi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.361,
    height: 26.361,
    viewBox: "0 0 26.361 26.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_943",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 943",
    transform: "translate(-775.69 -2797.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-twitter-5",
    d: "M1811,1754.471a5.421,5.421,0,0,1-1.553.426,2.718,2.718,0,0,0,1.19-1.5,5.417,5.417,0,0,1-1.718.659,2.705,2.705,0,0,0-4.608,2.466,7.678,7.678,0,0,1-5.573-2.824,2.706,2.706,0,0,0,.839,3.61,2.681,2.681,0,0,1-1.224-.338,2.707,2.707,0,0,0,2.167,2.688,2.7,2.7,0,0,1-1.221.046,2.707,2.707,0,0,0,2.526,1.877,5.442,5.442,0,0,1-4.006,1.119,7.689,7.689,0,0,0,11.831-6.83A5.45,5.45,0,0,0,1811,1754.471Z",
    transform: "translate(-1014.985 1052.965)",
    fill: "#d19f46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_5",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 5",
    transform: "translate(775.69 2797.794)",
    fill: "none",
    stroke: "#d19f46",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.181,
    cy: 13.181,
    r: 13.181,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.181,
    cy: 13.181,
    r: 12.681,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwi);
export default __webpack_public_path__ + "static/media/icon_twi.b6f12a06144b569f475179c145de23cc.svg";
export { ForwardRef as ReactComponent };